export default __webpack_public_path__ + "072c65cec5c9e089ffeee84372829aaa.twig";